// src/assets/personality/index.js
import breeze from "./breeze.png";
import tide from "./tide.png";
import stone from "./stone.png";
import flame from "./flame.png";
import star from "./star.png";

// se tiver imagens para os 27 archetypes, importe e exporte aqui
// exemplo: import navigator from "./navigator.png";

const images = {
  breeze,
  tide,
  stone,
  flame,
  star,
  // navigator,
  // thinker,
  // ...
};

export default images;
